import React from 'react';

import PropTypes from 'prop-types';

import LazyLoadedImage from 'common/LazyLoadedImage';

import Link from './Link';

import LogoAhrefs from 'img/landing/ahrefs-logo.svg';
import LogoAxios from 'img/landing/axios-logo.svg';
import LogoCCI from 'img/landing/cci-logo.svg';
import LogoClickUp from 'img/landing/clickup-logo.svg';
import LogoHarness from 'img/landing/harness-logo.svg';
import LogoMercury from 'img/landing/mercury-logo.svg';
import LogoTypeform from 'img/landing/typeform-logo.svg';

import 'css/components/_LandingLogos.scss';

type Props = {
  loading: 'lazy' | 'eager';
};

const LandingLogos = ({ loading }: Props) => {
  return (
    <div className="landingLogos">
      <div className="logos">
        <Link to="/case-studies/ahrefs">
          <LazyLoadedImage
            alt="Ahrefs case study"
            className="logo ahrefs"
            loading={loading}
            src={LogoAhrefs}
          />
        </Link>
        <Link to="/case-studies/circleci">
          <LazyLoadedImage
            alt="CircleCI case study"
            className="logo cci"
            loading={loading}
            src={LogoCCI}
          />
        </Link>
        <Link to="/case-studies/axios">
          <LazyLoadedImage
            alt="Axios case study"
            className="logo axios"
            loading={loading}
            src={LogoAxios}
          />
        </Link>
        <Link to="/case-studies/clickup">
          <LazyLoadedImage
            alt="ClickUp case study"
            className="logo clickup"
            loading={loading}
            src={LogoClickUp}
          />
        </Link>
        <Link to="/case-studies">
          <LazyLoadedImage
            alt="Typeform case study"
            className="logo typeform"
            loading={loading}
            src={LogoTypeform}
          />
        </Link>
        <Link to="/case-studies">
          <LazyLoadedImage
            alt="Harness case study"
            className="logo harness"
            loading={loading}
            src={LogoHarness}
          />
        </Link>
        <Link to="/case-studies/mercury">
          <LazyLoadedImage
            alt="Mercury case study"
            className="logo mercury"
            loading={loading}
            src={LogoMercury}
          />
        </Link>
      </div>
    </div>
  );
};

LandingLogos.defaultProps = {
  loading: 'lazy',
};

LandingLogos.propTypes = {
  loading: PropTypes.oneOf(['lazy', 'eager']),
};

export default LandingLogos;
